import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { debounce } from 'lodash';
import AlertIcon from '../alert-icon';

// Import Selectors
import { getUser } from '../../modules/Auth/AuthReducer';

const ORGANIZATION_SWITCH = 'ORGANIZATION_SWITCH';
const ORGANIZATION_RESYNC = 'ORGANIZATION_RESYNC';

export default function (ComposedComponent) {
  class OrgAwearness extends Component {
    constructor() {
      super();
      this.state = {
        switchType: null,
      };
      this.debouncedSwitchType = debounce(this.switchType, 2000);
    }
    componentWillReceiveProps(nextProps) {
      const { user } = nextProps;

      const { location: { pathname } } = this.props;

      if (user._id) {
        const nextId = user.pretent_organization_id || null;
        const currentId = this.props.user.pretent_organization_id || null;
        if (nextId !== currentId) {
          this.setState({ switchType: ORGANIZATION_SWITCH });
          this.context.router.history.push({ pathname, query: {} });
          this.debouncedSwitchType();
        } else {
          const currentOrg = this.props.user.pretent_organization || this.props.user.organization;
          const newOrg = user.pretent_organization || user.organization;
          if (currentOrg.last_synced_date !== newOrg.last_synced_date) {
            // this.setState({ switchType: ORGANIZATION_RESYNC });
            this.setState({ switchType: null });
            this.debouncedSwitchType();
          }
        }
      }
    }

    switchType() {
      this.setState({ switchType: null });
    }

    render() {
      const { switchType } = this.state;
      const { user } = this.props;
      if (switchType) {
        const organization = user.pretent_organization || user.organization;
        return (
          <div className="container text-center">
            <h1 className="page-header">&nbsp;</h1>
            <AlertIcon />
            {switchType === ORGANIZATION_SWITCH && <p><em>switching to organization</em> <strong>{organization.display_name}</strong></p>}
            {switchType === ORGANIZATION_RESYNC && <p><em>finish syncing data for</em> <strong>{organization.display_name}</strong></p>}
          </div>
        );
      }
      return <ComposedComponent {... this.props} />;
    }
  }

  // Retrieve data from store as props
  function mapStateToProps(state) {
    return {
      user: getUser(state),
    };
  }

  OrgAwearness.propTypes = {
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.shape({
      user_id: PropTypes.string,
      organization: PropTypes.shape({}),
      pretent_organization: PropTypes.shape({}),
      pretent_organization_id: PropTypes.string,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
  };


  OrgAwearness.contextTypes = {
    router: PropTypes.object,
  };


  return connect(mapStateToProps)(OrgAwearness);
}
